// 中英文切换，根据浏览器默认语言
function getLocalLanguage(defaultValue) {
    var language = navigator.language.slice(0, 2)
    console.log(language)
    if(language) {
        return unescape(language)
    } else {
        return defaultValue
    }
}

const language = {
    zh: {
        hello: '好好学习，天天向上'
    },
    en: {
        hello: 'Good good study, day day up'
    }
}
export {
    getLocalLanguage,
    language
}

// vue使用{{ $t("hello") }}


// WEBPACK FOOTER //
// ./src/utils/language.js